import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export default class UserService {
  static get() {
    return fetch(`${apiUrl}/api/user/`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static getAddress() {
    return fetch(`${apiUrl}/api/address/`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static addAddress(address: any) {
    return fetch(`${apiUrl}/api/address/`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify(address),
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static getBoost() {
    return fetch(`${apiUrl}/api/user/boost`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static getBoostList() {
    return fetch(`${apiUrl}/api/boost/`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static boostProduct(productId: number) {
    return fetch(`${apiUrl}/api/user/boost`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({ product_id: productId }),
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }
  static update(data: any) {
    return fetch(`${apiUrl}/api/user/`, {
      method: "PUT",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static updateAvatar(data: FormData) {
    return fetch(`${apiUrl}/api/media/avatar`, {
      method: "PUT",
      headers: {
        "Content-type": "application/json",
      },
      body: data,
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static active(token: string) {
    return fetch(`${apiUrl}/api/user/active/${token}`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static forgot(email: string) {
    return fetch(`${apiUrl}/api/user/forgot`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify({ email: email }),
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static updatePassword(data: any) {
    return fetch(`${apiUrl}/api/user/update-password`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static updateFormPassword(data: any) {
    return axios.put(`${apiUrl}/api/user/update-password`, data, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    // fetch(, {

    //     headers: {
    //         'Accept': 'application/json',
    //         'Content-Type': 'application/json' ,
    //         'Authorization': `Bearer ${this.loginData.token}`,
    //     },
    //     method: 'PUT',
    //     body: JSON.stringify(data)
    // })
  }

  static handleError(error: Error): void {
    console.error(error);
  }
}
